import { Component, computed, inject, input } from '@angular/core';

import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';

import { MyBetsBet, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsEventModel } from '../../models/my-bets-event.model';
import { VisualizationType } from '../../models/my-bets-visualization-types';
import { MyBetsVisualizationService } from '../../services/my-bets-visualization.service';

@Component({
    selector: 'ms-my-bets-betbuilder-expanded-info',
    templateUrl: 'my-bets-betbuilder-expanded-info.html',
    styleUrl: './my-bets-betbuilder-expanded-info.component.scss',
})
export class MyBetsBetbuilderExpandedInfoComponent {
    bet = input.required<MyBetsBet>();
    event = input.required<MyBetsEventModel>();
    myBetsListContext = input.required<MyBetsListContext>();
    cashedOut = input(false);

    noVisualization = VisualizationType.NoVisualization;

    legTrackingDetails = computed(() => {
        return this.bet().betBuilderInfo!.legs.map((leg) => {
            const visualizationTrackingDetails = this.myBetsVisualizationService.getVisualizationDetails(
                this.event(),
                this.bet().sportId,
                leg.marketId,
            );

            return { leg, trackingDetails: visualizationTrackingDetails };
        });
    });

    sitecoreMyBets = inject(SitecoreMyBetsConfig);
    private myBetsVisualizationService = inject(MyBetsVisualizationService);
}
